"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var React = __importStar(require("react"));
var app_1 = __importDefault(require("../../cart/app"));
var group_items_1 = __importDefault(require("../../cart/group-items"));
var app_2 = require("../app");
var subtotals_1 = __importDefault(require("./subtotals"));
var useEffect = React.useEffect, useState = React.useState, useContext = React.useContext;
exports.default = (function (props) {
    var _a = __read(useState(props.expanded), 2), isCartVisible = _a[0], setIsCartVisible = _a[1];
    var context = useContext(app_2.CheckoutContext);
    if (!context)
        return null;
    var cart = context.cart, imageUrls = context.imageUrls;
    var showCartForLargerScreens = function () {
        var _a;
        if (screen.width > 640 || ((_a = cart.lineItems) === null || _a === void 0 ? void 0 : _a.length) === 0) {
            setIsCartVisible(true);
        }
    };
    var groupedItems = (0, group_items_1.default)(window.cart.items);
    useEffect(function () {
        showCartForLargerScreens();
    }, []);
    var originalBundleValue = function (bundle) {
        var e_1, _a;
        if (!bundle.children)
            return undefined;
        try {
            for (var _b = __values(bundle.children), _c = _b.next(); !_c.done; _c = _b.next()) {
                var child = _c.value;
                if (child.properties && child.properties.original_bundle_value) {
                    return child.properties.original_bundle_value;
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return undefined;
    };
    return (React.createElement(React.Fragment, null,
        React.createElement("div", { className: 'grid-x grid-padding-x checkout-cart-dropdown' },
            React.createElement("div", { className: (0, classnames_1.default)({ 'cell small-8 padding-horizontal-4 text-black': true, 'text-left': !props.expandable }) }, "Order Summary"),
            props.expandable && (React.createElement("div", { className: 'cell small-4 text-right' },
                React.createElement("a", { className: 'padding-left-4', href: 'javascript:void(0)', onClick: function () { return setIsCartVisible(!isCartVisible); } },
                    React.createElement("img", { className: (0, classnames_1.default)({ 'order-summary-caret': true, open: isCartVisible }), src: imageUrls.arrowDown }))))),
        React.createElement("div", { className: (0, classnames_1.default)({ closed: !isCartVisible, 'checkout-order-summary-container': true }) },
            React.createElement("div", { className: 'bg-almost-white padding-2' },
                React.createElement(app_1.default, { embedded: true, expanded: false })),
            React.createElement("div", { className: 'padding-left-4 padding-right-4  margin-bottom-6' },
                React.createElement("div", { className: 'horizontal-divider-brownish-grey' })),
            React.createElement(subtotals_1.default, null))));
});
